import React from 'react'
import { SVGProps } from 'react'

const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M11.6735 8.80679L9.99885 7.13215C9.40077 6.53407 8.38402 6.77333 8.14479 7.55081C7.96537 8.08911 7.36728 8.38815 6.82901 8.26852C5.63284 7.96947 4.01801 6.41445 3.71897 5.15848C3.53954 4.62018 3.89839 4.02209 4.43667 3.84269C5.21418 3.60346 5.45341 2.58671 4.85533 1.98863L3.18069 0.313994C2.70222 -0.104665 1.98452 -0.104665 1.56586 0.313994L0.429504 1.45035C-0.706856 2.64652 0.549121 5.81637 3.36012 8.62737C6.17111 11.4384 9.34096 12.7542 10.5371 11.558L11.6735 10.4216C12.0922 9.94315 12.0922 9.22545 11.6735 8.80679Z" />
    </g>
  </svg>
)
export default PhoneIcon
